import utils from '../utils/index';
export const commonFilters = {
    filters: {
        momeyFormat(num, d) {
            if (!num) return "0.00"
            var s=num+"";
            if(!d)d=0;
            if(s.indexOf(".")==-1)s+=".";
            s+=new Array(d+1).join("0");
            if(new RegExp("^(-|\\+)?(\\d+(\\.\\d{0,"+(d+1)+"})?)\\d*$").test(s)){
                var s="0"+RegExp.$2,pm=RegExp.$1,a=RegExp.$3.length,b=true;
                if(a==d+2){
                    a=s.match(/\d/g);
                    if(parseInt(a[a.length-1])>4){
                        for(var i=a.length-2;i>=0;i--){
                            a[i]=parseInt(a[i])+1;
                            if(a[i]==10){
                                a[i]=0;
                                b=i!=1;
                            }else break;
                        }
                    }
                    s=a.join("").replace(new RegExp("(\\d+)(\\d{"+d+"})\\d$"),"$1.$2");
                }if(b)s=s.substr(1);
                return (pm+s).replace(/\.$/,"");
            }return this+"";
        },
        isEmpty (val) {
            return val || '--';
        },
        isEmptyUnit(val, extra = "") {
            if (val || val == 0) {
                return val + extra;
            }
            return "--"
        },
        tradeState (val) {
            return ["", "未完成", "已完成", "已关闭"][val] || '--';
        },
        orderStateStr (val) {
            return ['', '待付款', '待发货', '已发货', '已完成', '已关闭'][val];
        },
        payStateStr (val) {
            return ['', '待支付', '支付成功', '支付失败'][val];
        },
        payModeStr (val) {
            if (val || val === 0) {
                return ['无需支付','支付宝','微信','POS机','现金','第三方购买', '储值余额'][val];
            } else {
                return '--';
            }
        },
        orderPlatform (val) {
            let platformName = val.platform || val.platformName;
            return (platformName === '收银台' ? val.shopName : platformName) || '--';
        },
        buyType (val) {
            const buyType = {
                Buy: "购买",
				Exchange: "兑换",
                Upgrade: "升级",
                Frozen: "冻结",
                ValidityReset: "有效期重置",
                ExchangeCard: "补换卡",
                GoodsGrant: "补开卡"
            }
            return buyType[val];
        },
        ticketType(val) {
            return ['', '期限卡', '次卡'][val]
        },
        verifyState(val) {
            return ['', '已预约', '预约取消', '已核销'][val]
        },
        ticketState (val) {
            const {showState, isFrozen , isInvalid , isForbidden, isLocked} = val;
            const ticketState = {
                VALID: "已生效",
                USED: "已用完",
                OVERDUE: "已过期",
                INVALID: "已失效",
                LOCK: "已锁定",
            }
            // if (isFrozen) {
            //     return '已冻结';
            // } else if(isForbidden) {
            //     return '已禁用';
            // } else if(isLocked) {
            //     return '已锁定';
            // } else if(isInvalid) {
            //     return '已失效';
            // } else {
                return ticketState[showState];
            // }
        },
        invalidType (val) {
            return val ? ['--', '退款', '升级', '持有人更改', '赠送他人'][val] : '--';
        },
        myToFixed2 (val) {
            if (val !== null && typeof val !== 'undefined') {
                return utils.toFixed(val,2);
            } else {
                return '0.00';
            }
        },
        auditStateStr(val) {
            let auditState = {
                '0': "审批中",
                '1': "审批通过",
                "2": "无需审批",
                "-1": "审批不通过",
                "-2": "已撤回"
            }
            return auditState[String(val)];
        },
        goodsNum(val) {
            // if (!(Boolean(val) && Array.isArray(val))) {
            //     return '--'
            // }
            // return val.reduce((total, current) => total + current.totalNum, 0);
            return 1;
        },
        thousandFormat(val) {
            if (val !== 0 && !Boolean(val)) {
                return '--'
            }
            return (val+ '').replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g,'$1,');
        },
        couponType(val) {
            if (!Boolean(val)) {
                return '--'
            }
            return  ['', '满减劵', '折扣劵', '兑换劵'][val];
        },
        partyOrderStatus(val) {
            let partyOrderStatusList = ['--', '未归档', '已取消', '已归档'];
            return partyOrderStatusList[val];
        },
        SEC2DHM(val) {
            if (!Boolean(val)) {
                return '--';
            }
            let day = parseInt(Number(val) / 86400);
            let hour = parseInt((Number(val) - day * 86400) / 3600);
            let minute = parseInt((Number(val) - day * 86400 - hour * 3600) / 60);
            let effectiveDurationFormat = '';
            effectiveDurationFormat += day + '天';
            effectiveDurationFormat += hour + '小时';
            effectiveDurationFormat += minute + '分钟';
            return effectiveDurationFormat;
        },
        monitorState(val) {
            let monitorStateMap = {
                ok: '运行正常',
                warning: '运行预警',
                critical: '运行故障',
                unknown: '暂无数据'
            };
            return monitorStateMap[val];
        },
        byShopIdGetShopName(shopId) {
            let shopList = JSON.parse(sessionStorage.getItem('shopList'));
            if (!shopList || !shopList.length) {
                return "";
            }
            for (var i = 0; i < shopList.length; i++) {
                if (shopList[i].id == shopId) {
                    return shopList[i].name;
                }
            }
        }
    }
}
